import { render, staticRenderFns } from "./ExistingWillChangesRelationshipDetails.vue?vue&type=template&id=448eb8c2"
import script from "./ExistingWillChangesRelationshipDetails.vue?vue&type=script&lang=js"
export * from "./ExistingWillChangesRelationshipDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports